const daysInMonth = (month: number, year: number) => new Date(year, month, 0).getDate();

const minTwoDigits = (number) => (number < 10 ? '0' : '') + number;

const currentYear = new Date().getFullYear();

const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
    title: minTwoDigits(start + i * step),
    const: minTwoDigits(start + i * step),
  }));

const yearsArray = range(currentYear, 1900, -1);

const makeDaysArray = (days: number) => range(days, 1, -1);

const isValidNumber = (input: string): boolean => !Number.isNaN(parseInt(input, 10));

const isValidDate = (day: string, month: string, year: string) => {
  let isValid = false;

  if ((isValidNumber(day), isValidNumber(month), isValidNumber(year))) {
    const dateString = `${year}-${month}-${day}`;
    isValid = !Number.isNaN(Date.parse(dateString));
  }
  return isValid;
};

const getDateFromString = (day: string, month: string, year: string) => {
  const isValid = isValidDate(day, month, year);
  const dateString = `${month}/${day}/${year}`;
  const parts = dateString.split('/');
  return isValid ? new Date(Date.UTC(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]))) : null;
};

const getDisplayFormat = (locale: string) => {
  const dateFormat = new Intl.DateTimeFormat(locale);
  const formatArray = dateFormat.formatToParts();

  const dateString = formatArray
    .map((formatPart) => {
      if (formatPart.value === '/') return null;
      return formatPart.type[0];
    })
    .join('');

  return dateString;
};

export { daysInMonth, yearsArray, makeDaysArray, getDateFromString, getDisplayFormat };
